export default __webpack_public_path__ + "static/media/Google.829f3299.svg";